module.exports = __webpack_public_path__ + "img/20210903_101827.d4affc44.png";